<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="67"
        height="67"
        viewBox="0 0 67 67"
        fill="none"
    >
        <circle cx="33.3333" cy="33.3333" r="33.3333" fill="#F18169" />
        <path
            d="M22 22 L45 45 M45 22 L22 45"
            stroke="white"
            stroke-width="6"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
